<template>
    <div class="lw-cols multiple-rows multiple-rows-tl multiple-rows-tp multiple-rows-sl multiple-rows-sp learnworlds-align-center no-gutter lw-padding-normal lw-body-bg lw-user-panel">

        <div class="lw-padding-small lw-dark-bg -courses-box col span_4_of_12 span_6_of_12-tl span_12_of_12-tp span_6_of_12-sl span_12_of_12-sp flex-item" v-if="coursesVisibility">>
            <span class="learnworlds-icon normal standalone fas fa-book-open"></span>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large">
                <strong>{{userStats.courseCount}}</strong>
            </div>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-small">
                {{$t('common.courses')}}
            </div>
        </div>

        <div class="lw-padding-small -posts-box co span_4_of_12 span_6_of_12-tl span_12_of_12-tp span_6_of_12-sl span_12_of_12-sp flex-item"  v-if="postsVisibility">
            <span class="learnworlds-icon normal standalone fas fa-comment-alt"></span>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large">
                <strong>{{userStats.postsCount}}</strong>
            </div>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-small ">
                {{$t('profile.posts')}}
            </div>
        </div>

        <div class="lw-padding-small -messages-box col span_4_of_12 span_6_of_12-tl span_12_of_12-tp span_6_of_12-sl span_12_of_12-sp flex-item" v-if="messagesVisibility">
            <span class="learnworlds-icon normal standalone fas fa-envelope"></span>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large">
                <strong>{{userStats.messageCount}}</strong>
            </div>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-small">
                {{$t('profile.messages')}}
            </div>
        </div>
        <div class="lw-padding-small lw-brand-accent1-bg -hours-box col span_4_of_12 span_6_of_12-tl span_12_of_12-tp span_6_of_12-sl span_12_of_12-sp flex-item" v-if="hoursVisibility">
            <span class="learnworlds-icon normal standalone fas fa-clock"></span>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large">
                <strong>{{userStats.learningHours}}</strong>
            </div>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-small">
                {{$t('common.hours')}}
            </div>
        </div>

        <div class="lw-padding-small -achievements-box col span_4_of_12 span_6_of_12-tl span_12_of_12-tp span_6_of_12-sl span_12_of_12-sp flex-item" v-if="certificatesVisibility">
            <span class="learnworlds-icon normal standalone fas fa-award"></span>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large">
                <strong>{{userStats.certificatesCount}}</strong>
            </div>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-small">
                {{$t('course.certificates')}}
            </div>
        </div>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "UserStatsLayout2",
        mixins: [
            ComponentTemplatesMixin
        ],
        props: {
            userStats: {
                type: Object,
                required: true,
            },
            coursesVisibility: {
                type: Boolean,
                default: true
            },
            hoursVisibility: {
                type: Boolean,
                default: true
            },
            postsVisibility: {
                type: Boolean,
                default: true
            },
            certificatesVisibility: {
                type: Boolean,
                default: true
            },
            messagesVisibility: {
                type: Boolean,
                default: true
            },
        },
        methods: {
            navigateToInbox () {
                this.emitAction('navigate-to-inbox');
            }
        }
    }
</script>
